/* ============================================================
   OSMANLI DOĞAL TAŞ — NUMEROLOJİ · ana motor
   Bağımlılıklar: numero.js (hesap), icerik.js (yorum), kure.js (3B)
   Ürün verisi Liquid'den #odt-nm-veri ile gelir (canlı fiyat/stok).
   ============================================================ */
(function () {
  'use strict';

  var kok = document.querySelector('.odt-nm');
  if (!kok || !window.ODTNumero || !window.ODTNumeroIcerik) return;

  var N = window.ODTNumero, I = window.ODTNumeroIcerik, K = window.ODTKure;

  /* ---------------------------------------------------------- yardımcı */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function paraFmt(kurus, bicim) {
    var t = kurus / 100;
    return t.toLocaleString('tr-TR', { minimumFractionDigits: t % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' ' + (bicim || 'TL');
  }

  var VERI = {};
  try { VERI = JSON.parse(($('#odt-nm-veri') || {}).textContent || '{}'); } catch (e) { VERI = {}; }
  var URUN = VERI.urunler || {}, PARA = VERI.para || 'TL';

  var AYLAR = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  var D = { ad: '', soyad: '', gun: 0, ay: 0, yil: 0, email: '',
            cevap: {}, i: 0, p: null, testId: '' };

  function yeniId() {
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
    for (var i = 0; i < 8; i++) r += abc.charAt(Math.floor(Math.random() * abc.length));
    return 'NM-' + r;
  }
  function sayiBilgi(s) { return I.SAYI[s] || I.SAYI[9]; }

  /* ---------------------------------------------------------- ekran geçişi
     Kural: sayfa KENDİLİĞİNDEN zıplamaz. Ama yeni ekranın üstü görünür alanın
     yukarısında kaldıysa oraya çekilir — yoksa kullanıcı boş ekrana bakıyor. */
  var ILK = true, kure = null, loshu = null, alan = null;
  function ekran(ad) {
    var y = window.pageYOffset;
    $$('.nm-screen', kok).forEach(function (n) {
      n.classList.toggle('is-on', n.dataset.screen === ad);
    });
    if (Math.round(window.pageYOffset) !== Math.round(y)) window.scrollTo(0, y);

    /* Ekran DEĞİŞİMİNDE aktif ekranı görünür alanın tepesine oturt.
       Soru ekranı tam yükseklikte (100svh) olduğu için soru + dört seçenek
       kaydırmaya gerek kalmadan bir ekranda görünür.
       Soru ARASI geçişlerde bu fonksiyon çağrılmaz — orada scroll hiç oynamaz.

       İki rAF gerekli: ekran() çağrıldıktan HEMEN sonra soruCiz() içeriği
       yazıyor ve layout değişiyor. Aynı karede hizalarsak hedef geçersizleşip
       sayfa yanlış yerde kalıyordu (ölçümde ekranın tepesi 62px aşağıda kaldı). */
    if (!ILK) {
      /* TEK hizalama çağrısı, layout oturduktan sonra. Konumu tarayıcı
         hesaplasın diye scrollIntoView kullanılıyor.
         Denenip bırakılanlar: (a) rect.top + pageYOffset — 3B tuvaller ilk
         karelerinde sayfayı ~70px uzattığı için ölçüm eskiyordu; (b) offsetTop
         zinciri — sabit 72px sapma verdi; (c) iki çağrı — birbiriyle yarıştı. */
      setTimeout(function () {
        var aktif = $('.nm-screen.is-on', kok);
        if (!aktif) return;
        if (Math.abs(aktif.getBoundingClientRect().top) <= 6) return;
        try { aktif.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
        catch (e) { aktif.scrollIntoView(true); }
      }, 620);
    }
    ILK = false;
  }

  /* ---------------------------------------------------------- yıldız tozu (CSS) */
  (function () {
    var w = $('.nm-stars', kok); if (!w) return;
    var n = window.innerWidth < 700 ? 46 : 92, h = '';
    for (var i = 0; i < n; i++) {
      h += '<i style="left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 100).toFixed(2) +
           '%;--dur:' + (2.6 + Math.random() * 4).toFixed(1) + 's;--del:' + (Math.random() * 5).toFixed(1) + 's"></i>';
    }
    w.innerHTML = h;
  })();

  /* ---------------------------------------------------------- GİRİŞ ekranı */
  var girisKure = null;
  function girisKureBasla() {
    var cv = $('#nmGirisKure', kok);
    if (!cv || !K || girisKure) return;
    girisKure = K.sayiKuresi(cv, {
      merkez: { sayi: 7, renk: '#a97cff', renk2: '#e3d4ff' },
      dugum: [
        { sayi: 3, renk: '#ffd24d', etiket: '' },
        { sayi: 9, renk: '#e05a6d', etiket: '' },
        { sayi: 1, renk: '#ff7a45', etiket: '' },
        { sayi: 6, renk: '#ff8fb1', etiket: '' }
      ]
    });
  }
  (function () {
    girisKureBasla();

    var gun = $('#nmGun', kok), ay = $('#nmAy', kok), yil = $('#nmYil', kok);
    var h = '<option value="">Gün</option>';
    for (var i = 1; i <= 31; i++) h += '<option value="' + i + '">' + i + '</option>';
    gun.innerHTML = h;
    h = '<option value="">Ay</option>';
    AYLAR.forEach(function (a, k) { h += '<option value="' + (k + 1) + '">' + a + '</option>'; });
    ay.innerHTML = h;
    h = '<option value="">Yıl</option>';
    var buYil = new Date().getFullYear();
    for (var y = buYil; y >= 1925; y--) h += '<option value="' + y + '">' + y + '</option>';
    yil.innerHTML = h;
  })();

  function girisDogrula() {
    var ad = $('#nmAd', kok).value.trim(), soyad = $('#nmSoyad', kok).value.trim();
    var g = +$('#nmGun', kok).value, a = +$('#nmAy', kok).value, y = +$('#nmYil', kok).value;
    var uyari = $('#nmGirisUyari', kok);
    var eksik = null, odak = null;

    if (ad.length < 2) { eksik = 'Adını yazar mısın?'; odak = $('#nmAd', kok); }
    else if (soyad.length < 2) { eksik = 'Soyadın numeroloji hesabının yarısını oluşturuyor — onu da yazmalısın.'; odak = $('#nmSoyad', kok); }
    else if (!g || !a || !y) { eksik = 'Doğum tarihini tam olarak seç.'; odak = !g ? $('#nmGun', kok) : (!a ? $('#nmAy', kok) : $('#nmYil', kok)); }
    else if (N.harfler(ad + soyad).length < 3) { eksik = 'İsminde harf bulamadım; Türkçe harflerle yazar mısın?'; odak = $('#nmAd', kok); }
    else {
      /* takvim doğrulaması: 31 Şubat gibi tarihleri eler */
      var t = new Date(y, a - 1, g);
      if (t.getDate() !== g || t.getMonth() !== a - 1) { eksik = 'Bu tarih takvimde yok — kontrol eder misin?'; odak = $('#nmGun', kok); }
    }

    if (eksik) {
      uyari.textContent = eksik;
      uyari.hidden = false;
      /* preventScroll: odaklanma sayfayı zıplatmasın */
      if (odak) { try { odak.focus({ preventScroll: true }); } catch (e) { } }
      return null;
    }
    uyari.hidden = true;
    return { ad: ad, soyad: soyad, gun: g, ay: a, yil: y };
  }

  $('#nmBasla', kok).addEventListener('click', function () {
    var v = girisDogrula(); if (!v) return;
    D.ad = v.ad; D.soyad = v.soyad; D.gun = v.gun; D.ay = v.ay; D.yil = v.yil;
    D.email = ($('#nmEmail', kok).value || '').trim();
    D.i = 0; D.cevap = {};
    if (girisKure) { girisKure.durdur(); girisKure = null; }
    ekran('soru');
    if (!alan && K) alan = K.rakamAlani($('#nmAlan', kok), '#a97cff');
    soruCiz();
  });

  /* ---------------------------------------------------------- SORULAR */
  function soruCiz() {
    var s = I.SORULAR[D.i], kap = $('#nmSoru', kok);
    var yuzde = Math.round((D.i / I.SORULAR.length) * 100);
    $('#nmIlerlemeCubuk', kok).style.width = yuzde + '%';
    $('#nmIlerlemeYazi', kok).textContent = (D.i + 1) + ' / ' + I.SORULAR.length;

    var h = '<div class="nm-q-no">' + (D.i + 1) + '. soru</div>' +
            '<h3 class="nm-q-t">' + esc(s.soru) + '</h3>' +
            '<p class="nm-q-alt">' + esc(s.alt) + '</p><div class="nm-q-opts">';
    s.secenek.forEach(function (o, k) {
      h += '<button type="button" class="nm-opt" data-v="' + esc(o.v) + '">' +
           '<span class="nm-opt-k">' + String.fromCharCode(65 + k) + '</span>' +
           '<span class="nm-opt-d">' + esc(o.d) + '</span></button>';
    });
    h += '</div>';
    kap.innerHTML = h;

    /* is-fresh: fare hareket edene kadar hover efekti kapalı —
       yoksa imleç bir önceki seçeneğin üstünde kalıp yanlış vurgu veriyor */
    kap.classList.add('is-fresh');
    var acil = function () { kap.classList.remove('is-fresh'); document.removeEventListener('mousemove', acil); };
    document.addEventListener('mousemove', acil);

    $$('.nm-opt', kap).forEach(function (b) {
      b.addEventListener('click', function () { cevapla(s.id, b.dataset.v, b); });
    });
  }

  var kilit = false;
  function cevapla(id, v, btn) {
    if (kilit) return;
    kilit = true;
    D.cevap[id] = v;
    btn.classList.add('is-sel');
    setTimeout(function () {
      kilit = false;
      D.i++;
      if (D.i < I.SORULAR.length) soruCiz();
      else hesapCalistir();
    }, 180);
  }

  $('#nmGeri', kok).addEventListener('click', function () {
    if (D.i > 0) { D.i--; soruCiz(); }
    else { ekran('gate'); }
  });

  /* ---------------------------------------------------------- HESAP animasyonu
     İsmin harflerinin tek tek sayıya dönüşünü gösteriyoruz. Bu, sonucun
     "sihir" değil hesap olduğunu anlatan tek görsel. */
  function hesapCalistir() {
    ekran('hesap');
    D.p = N.profil(D.ad, D.soyad, D.gun, D.ay, D.yil);
    D.testId = yeniId();

    var kap = $('#nmHesapHarf', kok);
    var harf = D.p.harfDetay;
    var h = '';
    harf.forEach(function (x, k) {
      h += '<span class="nm-hh' + (x.sesli ? ' is-sesli' : '') + '" style="--g:' + (k * 0.045).toFixed(2) + 's">' +
           '<b>' + esc(x.harf) + '</b><i>' + x.deger + '</i></span>';
    });
    kap.innerHTML = h;

    var adim = $('#nmHesapAdim', kok);
    var yy = D.p.yasamYolu;
    var metin = [
      'Harfler sayıya çevriliyor…',
      'İsim toplamı: ' + N.harfToplam(harf),
      'Doğum tarihi indirgeniyor: ' + D.gun + ' · ' + D.ay + ' · ' + D.yil,
      'Yaşam Yolu: ' + yy.adimlar.join(' → '),
      'Doğum karen çiziliyor…',
      'Zaman döngün hesaplanıyor…'
    ];
    var mi = 0;
    adim.textContent = metin[0];
    var tik = setInterval(function () {
      mi++;
      if (mi >= metin.length) {
        clearInterval(tik);
        setTimeout(function () {
          if (alan) { alan.durdur(); alan = null; }
          sonucCiz();
          ekran('sonuc');
          panelKaydet();
        }, 420);
        return;
      }
      adim.textContent = metin[mi];
    }, 620);
  }

  /* ---------------------------------------------------------- sepet (tema-native) */
  var CART_SECTIONS = [
    { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    { id: 'mobile-cart-icon-bubble', selector: '#mobile-cart-icon-bubble' },
    { id: 'cart-drawer', selector: '#CartDrawer' }
  ];
  function cartSections() {
    try { var s = Alpine.store('xCartHelper').getSectionsToRender(); if (s && s.length) return s; } catch (e) { }
    return CART_SECTIONS;
  }
  function swapCart(secs, payload) {
    if (!payload) return false;
    var ok = false;
    secs.forEach(function (s) {
      try {
        var e = document.querySelector(s.selector);
        if (e && payload[s.id]) {
          var src = new DOMParser().parseFromString(payload[s.id], 'text/html').querySelector(s.selector);
          if (src) { e.innerHTML = src.innerHTML; ok = true; }
        }
      } catch (err) { }
    });
    return ok;
  }
  function syncCart() {
    try {
      var sp = document.querySelector('#cart-icon-bubble span');
      if (sp) Alpine.store('xCartHelper').currentItemCount = parseInt(sp.textContent) || 0;
    } catch (e) { }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }
  var etiketYazildi = false;
  function sepetEtiketi() {
    if (etiketYazildi || !D.testId || !D.p) return;
    etiketYazildi = true;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Numeroloji': D.testId,
        'Yaşam Yolu': String(D.p.yasamYolu.deger),
        'Kader Sayısı': String(D.p.kader.deger)
      } })
    }).catch(function () { });
  }
  function sepetBildir(btn) {
    if (!VERI.sepet || !D.testId) return;
    var kart = btn && btn.closest ? btn.closest('.nm-p') : null;
    var p = kart ? URUN_HAR[kart.dataset.kid] : null;
    try {
      fetch(VERI.sepet, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ test_kod: D.testId, urun: p ? p.t : '' })
      }).catch(function () { });
    } catch (e) { }
  }
  function sepeteEkle(vid, btn, eski) {
    btn.disabled = true; btn.textContent = 'EKLENİYOR…';
    var secs = cartSections();
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1,
        sections: secs.map(function (s) { return s.id; }), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.textContent = 'STOKTA YOK';
          setTimeout(function () { btn.textContent = eski; btn.disabled = false; }, 1800);
          return;
        }
        btn.textContent = 'EKLENDİ ✓'; btn.classList.add('is-ok');
        if (res.j && res.j.sections && swapCart(secs, res.j.sections)) syncCart();
        sepetEtiketi();
        sepetBildir(btn);
        try { Alpine.store('xMiniCart').openCart(); } catch (e) { }
        setTimeout(function () { btn.textContent = eski; btn.disabled = false; btn.classList.remove('is-ok'); }, 2200);
      }).catch(function () {
        btn.textContent = 'HATA';
        setTimeout(function () { btn.textContent = eski; btn.disabled = false; }, 1800);
      });
  }

  /* ---------------------------------------------------------- ürün kartları */
  var URUN_SAY = 0, URUN_HAR = {};
  function urunler(handle, adet, etiket) {
    var liste = (URUN[handle] || []).slice(0, adet || 4);
    if (!liste.length) return '';
    var h = '<div class="nm-products">';
    liste.forEach(function (p) {
      var kid = 'nmp' + (++URUN_SAY); URUN_HAR[kid] = p;
      var vs = p.v || [];
      h += '<div class="nm-p" data-kid="' + kid + '">' +
           '<a class="nm-p-link" href="' + esc(p.u) + '">' +
           '<div class="nm-p-img">' +
           (p.g ? '<img src="' + esc(p.g) + '" alt="' + esc(p.t) + '" loading="lazy" width="400" height="400">' : '') +
           (etiket ? '<span class="nm-p-tag">' + esc(etiket) + '</span>' : '') + '</div>' +
           '<div class="nm-p-title">' + esc(p.t) + '</div>' +
           '<div class="nm-p-price">' + (p.k && p.k > p.f ? '<del>' + paraFmt(p.k, PARA) + '</del>' : '') +
           paraFmt(p.f, PARA) + '</div></a>';
      if (vs.length) {
        h += '<button type="button" class="nm-add" data-kid="' + kid + '">Sepete Ekle</button>';
        if (vs.length > 1) {
          h += '<div class="nm-sizes" hidden><span class="nm-sizes-lbl">' + esc(p.o || 'Beden') + ' seçin</span><div class="nm-sizes-row">';
          vs.forEach(function (v) {
            h += '<button type="button" class="nm-size" data-kid="' + kid + '" data-vid="' + v.i + '">' + esc(v.t) + '</button>';
          });
          h += '</div></div>';
        }
      } else {
        h += '<a class="nm-add" href="' + esc(p.u) + '">Ürünü İncele</a>';
      }
      h += '</div>';
    });
    return h + '</div>';
  }
  function urunOlaylari(kap) {
    $$('.nm-add[data-kid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = URUN_HAR[b.dataset.kid]; if (!p) return;
        var vs = p.v || [];
        if (vs.length === 1) { sepeteEkle(vs[0].i, b, 'Sepete Ekle'); return; }
        var kutu = b.parentNode.querySelector('.nm-sizes');
        if (kutu) { var acik = !kutu.hidden; kutu.hidden = acik; b.textContent = acik ? 'Sepete Ekle' : 'Kapat'; }
      });
    });
    $$('.nm-size[data-vid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var kart = b.closest('.nm-p'), ana = kart ? kart.querySelector('.nm-add') : null;
        $$('.nm-size', kart).forEach(function (x) { x.classList.remove('is-picked'); });
        b.classList.add('is-picked');
        sepeteEkle(b.dataset.vid, ana || b, 'Sepete Ekle').then(function () {
          var k = kart ? kart.querySelector('.nm-sizes') : null; if (k) k.hidden = true;
        });
      });
    });
  }

  /* ---------------------------------------------------------- panel */
  function kaynakBul() {
    try {
      var q = new URLSearchParams(location.search), u = q.get('utm_source') || q.get('ref');
      if (u) return String(u).slice(0, 60);
      if (!document.referrer) return 'dogrudan';
      var hh = new URL(document.referrer).hostname.replace(/^www\./, '');
      return hh === location.hostname.replace(/^www\./, '') ? 'site-ici' : hh.slice(0, 60);
    } catch (e) { return ''; }
  }
  function panelKaydet() {
    if (!VERI.panel || !D.p) return;
    var p = D.p;
    try {
      fetch(VERI.panel, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          test_kod: D.testId, tur: 'numeroloji',
          ad: D.ad, soyad: D.soyad, email: D.email,
          dogum_gun: D.gun, dogum_ay: D.ay, dogum_yil: D.yil,
          yasam_yolu: p.yasamYolu.deger, kader: p.kader.deger,
          ruh: p.ruhArzusu.deger, kisilik: p.kisilik.deger,
          olgunluk: p.olgunluk.deger, kisisel_yil: p.kisiselYil,
          dogum_gunu_sayisi: p.dogumGunu.deger,
          karmik: p.karmik.eksik, zorluklar: p.zorluklar,
          aktif_zirve: p.aktifZirve.sayi,
          cevaplar: D.cevap,
          cihaz: window.matchMedia('(max-width:820px)').matches ? 'mobil' : 'masaustu',
          kaynak: kaynakBul()
        })
      }).then(function(r){return r.json();}).then(function(res){ if(res&&res.kupon){ kuponGoster(res.kupon); } }).catch(function () { });
    } catch (e) { }
  }
  function kuponGoster(kod){ if(!kod)return; if(document.getElementById('nmKupon'))return;
    var pr=document.querySelector('.nm-products'); if(!pr)return;
    var box=document.createElement('div'); box.id='nmKupon'; box.className='nh-kupon';
    box.innerHTML='<span class="nh-kupon-et">🎁 Sana Özel Hediye</span>'+
      '<p class="nh-kupon-a">Sayılarını çözdün — <b>tüm sepetine %10 indirim</b>. 1 hafta geçerli · tek kullanımlık · diğer indirimlerle birleşir.</p>'+
      '<div class="nh-kupon-kod"><code>'+esc(kod)+'</code><button type="button" class="nh-kupon-kopya" id="nmKuponKopya">Kopyala</button></div>';
    pr.parentNode.insertBefore(box,pr);
    var kb=document.getElementById('nmKuponKopya'); if(kb)kb.onclick=function(){ var ok=false; try{ navigator.clipboard.writeText(kod); ok=true; }catch(e){} if(!ok){try{var tmp=document.createElement('textarea');tmp.value=kod;document.body.appendChild(tmp);tmp.select();document.execCommand('copy');tmp.remove();}catch(e2){}} var t=kb.textContent; kb.textContent='✓ Kopyalandı'; kb.classList.add('ok'); setTimeout(function(){kb.textContent=t;kb.classList.remove('ok');},1900); };
  }

  /* ---------------------------------------------------------- derin katman */
  function derin(baslik, icHtml) {
    return '<details class="nm-derin"><summary>' + esc(baslik || 'Daha derine in') +
           '</summary><div class="nm-derin-ic">' + icHtml + '</div></details>';
  }
  function rozet(sayi, etiket, kucuk) {
    var b = sayiBilgi(sayi);
    return '<span class="nm-rozet' + (kucuk ? ' is-sm' : '') + '" style="--r:' + b.renk + ';--r2:' + b.renk2 + '">' +
           '<b>' + sayi + '</b>' + (etiket ? '<i>' + esc(etiket) + '</i>' : '') + '</span>';
  }
  function bolum(id, ustBaslik, baslik, ic) {
    return '<section class="nm-sec" id="' + id + '">' +
           '<div class="nm-sec-hd"><span class="nm-sec-ust">' + esc(ustBaslik) + '</span>' +
           '<h3 class="nm-sec-t">' + esc(baslik) + '</h3></div>' + ic + '</section>';
  }

  /* ---------------------------------------------------------- SONUÇ */
  function sonucCiz() {
    var p = D.p, kap = $('#nmSonuc', kok);
    var yy = p.yasamYolu.deger, byy = sayiBilgi(yy);
    var alanKey = D.cevap.alan || 'benlik';
    var alanIc = I.ALAN[alanKey];

    /* sonuç ekranının ana rengini yaşam yolu sayısı belirler */
    kok.style.setProperty('--nm-ana', byy.renk);
    kok.style.setProperty('--nm-ana2', byy.renk2);

    var h = '';

    /* ---- 1. KİMLİK KARTI ---- */
    h += '<div class="nm-hero">' +
         '<div class="nm-hero-kod">' + esc(D.testId) + '</div>' +
         '<div class="nm-hero-ad">' + esc(p.tamIsim) + '</div>' +
         '<div class="nm-hero-tarih">' + D.gun + ' ' + AYLAR[D.ay - 1] + ' ' + D.yil + '</div>' +
         '<div class="nm-hero-buyuk" style="--r:' + byy.renk + ';--r2:' + byy.renk2 + '">' +
           '<span class="nm-hero-sim">' + byy.simge + '</span>' +
           '<span class="nm-hero-n">' + yy + '</span>' +
         '</div>' +
         '<div class="nm-hero-ark">' + esc(byy.ad) + (byy.usta ? ' <em>· usta sayı</em>' : '') + '</div>' +
         '<p class="nm-hero-oz">' + esc(byy.oz) + '</p>' +
         '<div class="nm-hero-mini">' +
           rozet(p.kader.deger, 'Kader') + rozet(p.ruhArzusu.deger, 'Ruh') +
           rozet(p.kisilik.deger, 'Kişilik') + rozet(p.olgunluk.deger, 'Olgunluk') +
         '</div></div>';

    /* ---- 2. 3B SAYI KÜRESİ ---- */
    h += '<div class="nm-kure-wrap">' +
         '<canvas id="nmKure" class="nm-kure" aria-label="Sayı küresi"></canvas>' +
         '<p class="nm-kure-not">Ortadaki Yaşam Yolun; çemberdeki dokuz haneden seninkiler yanıyor, ' +
         'altta seni tamamlayan dört sayı duruyor. ' +
         '<span class="nm-ipucu">Mührü sürükleyerek çevirebilirsin.</span></p></div>';

    /* ---- 3. YAŞAM YOLU ---- */
    var yyIc = '<p class="nm-buyuk-p">' + esc(byy.yol) + '</p>' +
      '<div class="nm-gg">' +
        '<div class="nm-gg-k is-guc"><h4>Gücün</h4><ul>' +
          byy.guc.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' +
        '<div class="nm-gg-k is-golge"><h4>Gölgen</h4><ul>' +
          byy.golge.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' +
      '</div>' +
      '<div class="nm-ders"><span>Bu hayattaki dersin</span><strong>' + esc(byy.ders) + '</strong></div>' +
      derin('Yaşam Yolu nasıl hesaplandı?',
        '<p>Doğum tarihinin her parçası ayrı ayrı indirgenir, sonra toplanır:</p>' +
        '<div class="nm-hesap-satir"><span>Gün</span><b>' + D.gun + ' → ' + N.indirge(D.gun) + '</b></div>' +
        '<div class="nm-hesap-satir"><span>Ay</span><b>' + D.ay + ' → ' + N.indirge(D.ay) + '</b></div>' +
        '<div class="nm-hesap-satir"><span>Yıl</span><b>' + D.yil + ' → ' + N.indirge(D.yil) + '</b></div>' +
        '<div class="nm-hesap-satir is-son"><span>Toplam</span><b>' + p.yasamYolu.adimlar.join(' → ') + '</b></div>' +
        (byy.usta ? '<p><strong>' + yy + ' bir usta sayıdır</strong> — tek haneye indirilmez. Numerolojide 11, 22 ve 33 kendi başlarına bırakılır; taşıdıkları potansiyel de zorluk da daha yüksektir.</p>' : '') +
        '<p>Yaşam Yolu, numerolojinin en belirleyici sayısıdır: ne yapacağını değil, <em>nasıl</em> yaşayacağını anlatır. Doğum tarihi değişmediği için ömür boyu sabittir.</p>'
      );
    h += bolum('nmYY', 'Ana sayın · ' + byy.gezegen, 'Yaşam Yolu ' + yy + ' — ' + byy.ad, yyIc);

    /* ---- 4. İSİM ÇÖZÜMLEMESİ ---- */
    var harfHtml = '<div class="nm-harfler">';
    p.harfDetay.forEach(function (x) {
      harfHtml += '<span class="nm-hf' + (x.sesli ? ' is-sesli' : '') + '"><b>' + esc(x.harf) + '</b><i>' + x.deger + '</i></span>';
    });
    harfHtml += '</div><div class="nm-harf-lgn"><span class="nm-lg is-sesli"></span> Sesli harfler → Ruh Arzusu' +
                '<span class="nm-lg"></span> Sessiz harfler → Kişilik</div>';

    var isimIc = harfHtml +
      '<div class="nm-uc">' +
        '<div class="nm-uc-k"><div class="nm-uc-h">' + rozet(p.kader.deger) + '</div>' +
          '<h4>Kader Sayısı ' + p.kader.deger + '</h4><span class="nm-uc-alt">Tüm harfler · ' + p.kader.adimlar.join(' → ') + '</span>' +
          '<p>' + esc(sayiBilgi(p.kader.deger).kader) + '</p></div>' +
        '<div class="nm-uc-k"><div class="nm-uc-h">' + rozet(p.ruhArzusu.deger) + '</div>' +
          '<h4>Ruh Arzusu ' + p.ruhArzusu.deger + '</h4><span class="nm-uc-alt">Sesli harfler · ' + p.ruhArzusu.adimlar.join(' → ') + '</span>' +
          '<p>' + esc(sayiBilgi(p.ruhArzusu.deger).ruh) + '</p></div>' +
        '<div class="nm-uc-k"><div class="nm-uc-h">' + rozet(p.kisilik.deger) + '</div>' +
          '<h4>Kişilik ' + p.kisilik.deger + '</h4><span class="nm-uc-alt">Sessiz harfler · ' + p.kisilik.adimlar.join(' → ') + '</span>' +
          '<p>' + esc(sayiBilgi(p.kisilik.deger).kisilik) + '</p></div>' +
      '</div>' +
      derin('Türkçe harfler nasıl sayıya çevriliyor?',
        '<p>Pisagor tablosu Latin alfabesi için kurulmuştur: A=1, B=2 … I=9, sonra J=1 diye başa döner. ' +
        'Türkçeye özgü harfler en yakın karşılığına indirgenir:</p>' +
        '<div class="nm-tr-tablo"><span>Ç → C</span><span>Ğ → G</span><span>İ → I</span><span>Ö → O</span><span>Ş → S</span><span>Ü → U</span></div>' +
        '<p>Sesli harfler <strong>A E I İ O Ö U Ü</strong> olarak alınır. İngilizce numerolojisinde Y bazen sesli sayılır; ' +
        'Türkçede Y sessiz bir harf olduğu için burada <strong>sessiz</strong> kabul edilmiştir.</p>' +
        '<p>Kader sayısı nüfustaki tam isminle hesaplanır — bu yüzden soyadın da hesaba dahildir. ' +
        'İsim değişirse (evlilik, mahkeme kararı) kader sayısı da değişir; yaşam yolu ise asla değişmez.</p>'
      );
    h += bolum('nmIsim', 'İsminin titreşimi', 'İsim Çözümlemesi', isimIc);

    /* ---- 5. ODAK ALANI OKUMASI ---- */
    var odakIc = '<p class="nm-odak-giris">' + esc(alanIc.giris) + '</p>' +
      '<div class="nm-odak-blok"><div class="nm-odak-bs">' + rozet(yy, 'Yaşam Yolu', true) + '</div>' +
        '<p>' + esc(alanIc.sayi[yy]) + '</p></div>';
    if (p.kader.deger !== yy) {
      odakIc += '<div class="nm-odak-blok"><div class="nm-odak-bs">' + rozet(p.kader.deger, 'Kader', true) + '</div>' +
        '<p>' + esc(alanIc.sayi[p.kader.deger]) + '</p></div>';
    }
    if (p.ruhArzusu.deger !== yy && p.ruhArzusu.deger !== p.kader.deger) {
      odakIc += '<div class="nm-odak-blok"><div class="nm-odak-bs">' + rozet(p.ruhArzusu.deger, 'Ruh Arzusu', true) + '</div>' +
        '<p>' + esc(alanIc.sayi[p.ruhArzusu.deger]) + '</p></div>';
    }
    h += bolum('nmOdak', 'Sorduğun alan', alanIc.ad, odakIc);

    /* ---- 6. LO SHU DOĞUM KARESİ ---- */
    var oklar = I.OKLAR.filter(function (ok) {
      return ok.hane.every(function (n) { return (p.loShu.sayim[n] || 0) > 0; });
    });
    var kareIc = '<div class="nm-loshu-wrap">' +
      '<canvas id="nmLoShu" class="nm-loshu" aria-label="Lo Shu doğum karesi"></canvas></div>' +
      '<p class="nm-loshu-not">Doğum tarihindeki rakamlar taşa oyulmuş 3×3 kareye yerleşir. Işık yükselen haneler sende <strong>güçlü</strong>, ' +
      'karanlık kalanlar <strong>eksik</strong> alanları gösterir.</p>';

    var doluHtml = '', bosHtml = '';
    for (var n1 = 1; n1 <= 9; n1++) {
      var adet = p.loShu.sayim[n1] || 0, ls = I.LOSHU[n1];
      var satir = '<div class="nm-ls-satir"><span class="nm-ls-n' + (adet ? '' : ' is-bos') + '">' + n1 +
        (adet > 1 ? '<i>×' + adet + '</i>' : '') + '</span>' +
        '<div><strong>' + esc(ls.ad) + '</strong> <em>' + esc(ls.alan) + '</em>' +
        '<p>' + esc(adet === 0 ? ls.yok : (adet >= 3 ? ls.cok : (adet === 2 ? ls.cok : ls.var1))) + '</p></div></div>';
      if (adet) doluHtml += satir; else bosHtml += satir;
    }
    if (doluHtml) kareIc += '<h4 class="nm-ls-h">Karendeki güçlü haneler</h4>' + doluHtml;
    if (bosHtml) kareIc += '<h4 class="nm-ls-h is-bos">Boş kalan haneler</h4>' +
      '<p class="nm-ls-aciklama">Boş hane bir kusur değil; bu hayatta üzerinde çalışman istenen alan.</p>' + bosHtml;

    if (oklar.length) {
      kareIc += '<div class="nm-oklar"><h4>Karendeki oklar</h4>' +
        '<p class="nm-ls-aciklama">Bir satır, sütun ya da çapraz tamamen doluysa buna “ok” denir ve o alanda doğuştan güç anlamına gelir.</p>';
      oklar.forEach(function (ok) {
        kareIc += '<div class="nm-ok"><span class="nm-ok-h">' + ok.hane.join(' · ') + '</span>' +
          '<div><strong>' + esc(ok.ad) + '</strong><p>' + esc(ok.metin) + '</p></div></div>';
      });
      kareIc += '</div>';
    } else {
      kareIc += '<p class="nm-ls-aciklama">Karende tamamlanmış bir hat (ok) yok. Bu, tek bir alanda aşırı yoğunlaşmadığın, ' +
        'gücünün dağınık ama dengeli olduğu anlamına gelir.</p>';
    }
    h += bolum('nmKare', 'Doğum karen', 'Lo Shu Karesi', kareIc);

    /* ---- 7. KARMİK DERSLER ---- */
    var karmikIc;
    if (p.karmik.eksik.length) {
      karmikIc = '<p class="nm-karmik-giris">İsminde hiç geçmeyen sayılar, bu hayatta öğrenmen istenen konuları gösterir. ' +
        'Eksiklik değil, müfredat.</p>';
      p.karmik.eksik.forEach(function (n2) {
        karmikIc += '<div class="nm-karmik-k">' + rozet(n2, '', true) +
          '<p>' + esc(I.KARMIK[n2]) + '</p></div>';
      });
    } else {
      karmikIc = '<p class="nm-karmik-giris">İsminde 1’den 9’a kadar bütün sayılar geçiyor. Bu nadir bir durumdur: ' +
        'belirgin bir karmik boşluğun yok, yani bu hayatta tek bir konuya sıkışmıyorsun. ' +
        'Dezavantajı şu — hiçbir alan seni zorlamadığı için hangisinde derinleşeceğini kendin seçmelisin.</p>';
    }
    h += bolum('nmKarmik', 'İsminde olmayanlar', 'Karmik Dersler', karmikIc);

    /* ---- 8. ZAMAN HARİTASI ---- */
    var aktif = p.aktifZirve;
    var zamanIc = '<p class="nm-zaman-giris">Hayat dört dönemden geçer. Her dönemin kendi teması, kendi sınavı vardır. ' +
      'Şu an <strong>' + aktif.no + '. dönemdesin</strong>.</p><div class="nm-timeline">';
    p.zirveler.forEach(function (z, zi) {
      var bz = sayiBilgi(z.sayi);
      var aktifMi = z.no === aktif.no;
      zamanIc += '<div class="nm-tl' + (aktifMi ? ' is-aktif' : '') + '" style="--r:' + bz.renk + '">' +
        '<div class="nm-tl-yas">' + (zi === 0 ? '0' : z.bas) + '–' + (z.bit === 99 ? '∞' : z.bit) + ' yaş</div>' +
        '<div class="nm-tl-n">' + z.sayi + '</div>' +
        '<div class="nm-tl-ad">' + esc(bz.ad) + '</div>' +
        '<p class="nm-tl-m">' + esc(bz.zirve) + '</p>' +
        (aktifMi ? '<span class="nm-tl-simdi">Şu an buradasın</span>' : '') + '</div>';
    });
    zamanIc += '</div>';

    var z0 = p.zorluklar;
    var zorlukAktif = aktif.no <= 2 ? z0[aktif.no - 1] : (aktif.no === 3 ? z0[2] : z0[3]);
    zamanIc += '<div class="nm-zorluk"><h4>Bu dönemin zorluğu — ' + esc(I.ZORLUK[zorlukAktif].ad) + '</h4>' +
      '<p>' + esc(I.ZORLUK[zorlukAktif].metin) + '</p></div>';

    zamanIc += derin('Diğer dönemlerin zorlukları',
      z0.map(function (zz, k) {
        return '<div class="nm-hesap-satir"><span>' + (k + 1) + '. dönem — ' + esc(I.ZORLUK[zz].ad) + '</span><b>' + zz + '</b></div>' +
               '<p class="nm-mini-p">' + esc(I.ZORLUK[zz].metin) + '</p>';
      }).join('') +
      '<p>Zorluk sayıları doğum tarihindeki farklardan hesaplanır. Ceza değil, tekrar eden bir sınav gibidir: ' +
      'aynı tema hayatının farklı dönemlerinde farklı kılıklarda karşına çıkar.</p>'
    );
    h += bolum('nmZaman', 'Dönemlerin', 'Zaman Haritası', zamanIc);

    /* ---- 9. KİŞİSEL YIL ---- */
    var ky = p.kisiselYil, yb = I.YIL[ky], kyB = sayiBilgi(ky);
    var kam = p.kisiselAy, yamB = I.YIL[kam];
    var yilIc = '<div class="nm-yil-kart" style="--r:' + kyB.renk + ';--r2:' + kyB.renk2 + '">' +
      '<div class="nm-yil-n">' + ky + '</div>' +
      '<div class="nm-yil-i"><span class="nm-yil-ust">' + p.suYil + ' · Kişisel Yılın</span>' +
      '<h4>' + esc(yb.ad) + '</h4><p>' + esc(yb.ozet) + '</p></div></div>' +
      '<div class="nm-yy2">' +
        '<div class="nm-yy2-k is-yap"><h4>Bu yıl işine yarayacak</h4><ul>' +
          yb.yap.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' +
        '<div class="nm-yy2-k is-yapma"><h4>Bu yıl seni yoracak</h4><ul>' +
          yb.yapma.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' +
      '</div>' +
      '<div class="nm-ay-kart">' + rozet(kam, '', true) +
        '<div><strong>' + AYLAR[new Date().getMonth()] + ' ayın: ' + esc(yamB.ad) + '</strong>' +
        '<p>' + esc(yamB.ozet) + '</p></div></div>' +
      derin('Kişisel yıl nasıl hesaplanır?',
        '<p>Doğum günün + doğum ayın + içinde bulunulan yıl. Sonuç 1–9 arasına indirgenir; ' +
        'usta sayı kuralı burada uygulanmaz çünkü bu bir <em>döngü</em>dür ve dokuz basamaklıdır.</p>' +
        '<div class="nm-hesap-satir"><span>Doğum günü</span><b>' + D.gun + ' → ' + N.indirge(D.gun, false) + '</b></div>' +
        '<div class="nm-hesap-satir"><span>Doğum ayı</span><b>' + D.ay + ' → ' + N.indirge(D.ay, false) + '</b></div>' +
        '<div class="nm-hesap-satir"><span>Bu yıl</span><b>' + p.suYil + ' → ' + N.indirge(p.suYil, false) + '</b></div>' +
        '<div class="nm-hesap-satir is-son"><span>Kişisel yılın</span><b>' + ky + '</b></div>' +
        '<p>1. yılda ekilen, 9. yılda kapanır. Hangi yılda olduğunu bilmek, bir işe başlamak ya da bitirmek için ' +
        'doğru zamanı seçmeni sağlar.</p>'
      );
    h += bolum('nmYil', p.suYil + ' senin için', 'Kişisel Yılın: ' + ky + ' — ' + yb.ad, yilIc);

    /* ---- 10. TAŞLARIN ---- */
    var ruhB = sayiBilgi(p.ruhArzusu.deger);
    var tasSeti = {};
    byy.taslar.forEach(function (t) { tasSeti[t] = 'Yaşam Yolu ' + yy; });
    ruhB.taslar.slice(0, 2).forEach(function (t) { if (!tasSeti[t]) tasSeti[t] = 'Ruh Arzusu ' + p.ruhArzusu.deger; });
    kyB.taslar.slice(0, 1).forEach(function (t) { if (!tasSeti[t]) tasSeti[t] = p.suYil + ' yılı'; });

    var tasIc = '<p class="nm-tas-giris">Numerolojide her sayının bir gezegeni vardır; taşlar da o gezegenin ' +
      'titreşimine göre seçilir. Senin sayılarının taşları:</p><div class="nm-taslar">';
    Object.keys(tasSeti).forEach(function (t) {
      tasIc += '<div class="nm-tas"><strong>' + esc(t) + '</strong><span>' + esc(tasSeti[t]) + '</span></div>';
    });
    tasIc += '</div>';
    h += bolum('nmTas', 'Hangi taş, neden', 'Taşlarının Listesi', tasIc);

    /* ---- 11. ÜRÜNLER ---- */
    var urunIc = '';
    var u1 = urunler(byy.burc, 4, 'Yaşam Yolu ' + yy);
    if (u1) urunIc += '<div class="nm-ug"><h4>' + yy + ' · ' + esc(byy.gezegen) + ' titreşimi</h4>' +
      '<p class="nm-ug-alt">Yaşam yolu sayının gezegeni ' + esc(byy.gezegen) + '. Bu gezegenin taşları ' +
      esc(byy.burcAd) + ' koleksiyonunda toplanıyor.</p>' + u1 + '</div>';

    var u2 = urunler(byy.cakra, 4, esc(byy.cakraAd));
    if (u2) urunIc += '<div class="nm-ug"><h4>' + esc(byy.cakraAd) + ' merkezin</h4>' +
      '<p class="nm-ug-alt">' + yy + ' sayısı bedende ' + esc(byy.cakraAd) + ' merkezinde çalışır. ' +
      'Bu merkezi destekleyen taşlar:</p>' + u2 + '</div>';

    if (p.ruhArzusu.deger !== yy) {
      var u3 = urunler(ruhB.burc, 4, 'Ruh Arzusu ' + p.ruhArzusu.deger);
      if (u3) urunIc += '<div class="nm-ug"><h4>Ruh arzun · ' + p.ruhArzusu.deger + '</h4>' +
        '<p class="nm-ug-alt">Sesli harflerinden çıkan sayı, içinde ne istediğini gösterir. ' +
        'Bu titreşimi besleyen taşlar:</p>' + u3 + '</div>';
    }

    if (ky !== yy && ky !== p.ruhArzusu.deger) {
      var u4 = urunler(kyB.burc, 4, p.suYil + ' yılın');
      if (u4) urunIc += '<div class="nm-ug"><h4>' + p.suYil + ' yılı için</h4>' +
        '<p class="nm-ug-alt">Bu yıl ' + ky + ' döngüsündesin. Yılın temasını destekleyen taşlar:</p>' + u4 + '</div>';
    }
    /* Bkz. odt-harita.js'teki aynı not: önce eksik/gölge adlandırılıyor,
       sonra taşın ne yapacağı, sonra nasıl kullanılacağı. */
    if (urunIc) {
      var golgeAd = (byy.golge && byy.golge.length)
        ? byy.golge.slice(0, 2).join(' ve ').toLocaleLowerCase('tr') : '';
      var urunGiris = '<p class="nm-ug-alt" style="margin:0 0 22px">' +
        (golgeAd ? 'Sayıların en çok <b>' + esc(golgeAd) + '</b> tarafında zorlanıyor. ' : '') +
        'Aşağıdaki taşlar süs olsun diye değil, tam da bu tarafı desteklemek için seçildi. ' +
        'Birini seç ve günün büyük kısmında üzerinde taşı — etki süreklilikte.</p>';
      h += bolum('nmUrun', 'Zayıf tarafını destekle', 'Eksiğini Tamamlayan Taşlar', urunGiris + urunIc);
    }

    /* ---- 12. KENDİN TASARLA ---- */
    var tasAdlar = Object.keys(tasSeti).slice(0, 4);
    h += '<div class="nm-kt">' +
      '<div class="nm-kt-ic"><span class="nm-kt-ust">Kendi tasarımın</span>' +
      '<h3>Bu taşlarla kendi bilekliğini tasarla</h3>' +
      '<p>Sayılarından çıkan ' + esc(tasAdlar.join(', ')) + ' taşlarını tek bir bileklikte birleştirebilirsin. ' +
      'Taşları sen seçersin, biz sana özel üretiriz.</p>' +
      '<a class="nm-kt-btn" href="/pages/kendin-tasarla">Kendin Tasarla →</a></div></div>';

    /* ---- 13. KAYDET / PAYLAŞ ---- */
    h += '<div class="nm-son">' +
      '<div class="nm-eposta" id="nmEpostaKutu">' +
        '<h4>Analizini e-posta ile gönderelim</h4>' +
        '<p>Sayıların, taşların ve sana özel seçilen ürünler tek bir e-postada dursun.</p>' +
        '<div class="nm-eposta-row">' +
          '<input type="email" id="nmEpostaAdres" placeholder="e-posta adresin" value="' + esc(D.email) + '" autocomplete="email">' +
          '<button type="button" id="nmEpostaGonder">Gönder</button>' +
        '</div>' +
        '<div class="nm-eposta-durum" id="nmEpostaDurum" hidden></div>' +
      '</div>' +
      '<div class="nm-son-btns">' +
        '<button type="button" class="nm-btn-alt" id="nmTekrar">Yeniden Hesapla</button>' +
        '<button type="button" class="nm-btn-alt" id="nmPaylas">Paylaş</button>' +
      '</div>' +
      '<p class="nm-disclaimer">Numeroloji bir inanç ve yorum sistemidir; tıbbi, finansal veya hukuki tavsiye yerine geçmez. ' +
      'Hesaplar Pisagor sistemine göre yapılmıştır.</p>' +
    '</div>';

    kap.innerHTML = h;

    /* --- 3B bileşenleri sonuç DOM'a girdikten sonra başlat --- */
    if (K) {
      if (kure) kure.durdur();
      kure = K.sayiKuresi($('#nmKure', kap), {
        merkez: { sayi: yy, renk: byy.renk, renk2: byy.renk2, ad: byy.ad },
        dugum: [
          { sayi: p.kader.deger, renk: sayiBilgi(p.kader.deger).renk, etiket: 'Kader' },
          { sayi: p.ruhArzusu.deger, renk: sayiBilgi(p.ruhArzusu.deger).renk, etiket: 'Ruh' },
          { sayi: p.kisilik.deger, renk: sayiBilgi(p.kisilik.deger).renk, etiket: 'Kişilik' },
          { sayi: p.olgunluk.deger, renk: sayiBilgi(p.olgunluk.deger).renk, etiket: 'Olgunluk' }
        ]
      });
      if (loshu) loshu.durdur();
      loshu = K.loShu3B($('#nmLoShu', kap), {
        sayim: p.loShu.sayim, dizilim: p.loShu.dizilim,
        oklar: oklar.map(function (o) { return o.hane; }),
        renk: byy.renk, renk2: byy.renk2
      });
    }

    urunOlaylari(kap);

    $('#nmTekrar', kap).addEventListener('click', function () {
      if (kure) { kure.durdur(); kure = null; }
      if (loshu) { loshu.durdur(); loshu = null; }
      /* yeni test = yeni kod; sepet etiketi tekrar yazılabilmeli */
      etiketYazildi = false;
      ekran('gate');
      girisKureBasla();
    });
    $('#nmPaylas', kap).addEventListener('click', paylas);
    $('#nmEpostaGonder', kap).addEventListener('click', epostaGonder);
  }

  /* ---------------------------------------------------------- paylaş */
  function paylas() {
    var p = D.p;
    var metin = 'Numeroloji analizim: Yaşam Yolu ' + p.yasamYolu.deger + ' — ' +
      sayiBilgi(p.yasamYolu.deger).ad + '. Sen de kendi sayılarına bak:';
    var url = location.origin + location.pathname;
    if (navigator.share) {
      navigator.share({ title: 'Numeroloji Analizi', text: metin, url: url }).catch(function () { });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(metin + ' ' + url).then(function () {
        var b = $('#nmPaylas', kok);
        if (b) { b.textContent = 'Kopyalandı ✓'; setTimeout(function () { b.textContent = 'Paylaş'; }, 2000); }
      }).catch(function () { });
    }
  }

  /* ---------------------------------------------------------- e-posta */
  function epostaGonder() {
    var adres = ($('#nmEpostaAdres', kok).value || '').trim();
    var durum = $('#nmEpostaDurum', kok);
    var btn = $('#nmEpostaGonder', kok);
    durum.hidden = false;
    durum.className = 'nm-eposta-durum';

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adres)) {
      durum.classList.add('is-hata');
      durum.textContent = 'Geçerli bir e-posta adresi yazar mısın?';
      return;
    }
    if (!VERI.eposta) {
      durum.classList.add('is-hata');
      durum.textContent = 'E-posta servisi şu an kapalı, kısa süre sonra tekrar dene.';
      return;
    }
    D.email = adres;
    btn.disabled = true; btn.textContent = 'Gönderiliyor…';
    durum.textContent = '';

    fetch(VERI.eposta, {
      method: 'POST', mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(epostaGovdesi(adres))
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) {
        btn.disabled = false; btn.textContent = 'Gönder';
        if (j && j.ok) {
          durum.classList.add('is-ok');
          durum.textContent = 'Gönderildi ✓  ' + adres + ' adresini kontrol et.';
          panelKaydet();
        } else {
          durum.classList.add('is-hata');
          durum.textContent = (j && j.mesaj) || 'Gönderilemedi, biraz sonra tekrar dener misin?';
        }
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Gönder';
        durum.classList.add('is-hata');
        durum.textContent = 'Bağlantı kurulamadı, biraz sonra tekrar dene.';
      });
  }

  /* E-posta gövdesi: sunucu bu veriyle HTML şablonu kurar.
     Ürün görselleri protokolsüz (//cdn…) gelebilir — https'e sabitliyoruz,
     yoksa e-posta istemcilerinde görsel çıkmıyor. */
  function epostaGovdesi(adres) {
    var p = D.p, byy = sayiBilgi(p.yasamYolu.deger);
    var alanKey = D.cevap.alan || 'benlik';

    function urunSec(handle, adet) {
      return (URUN[handle] || []).slice(0, adet || 2).map(function (x) {
        return {
          t: x.t,
          u: location.origin + x.u,
          g: (x.g || '').replace(/^\/\//, 'https://'),
          f: paraFmt(x.f, PARA)
        };
      });
    }
    var liste = urunSec(byy.burc, 2).concat(urunSec(byy.cakra, 2));

    var tasSeti = {};
    byy.taslar.forEach(function (t) { tasSeti[t] = 1; });
    sayiBilgi(p.ruhArzusu.deger).taslar.slice(0, 2).forEach(function (t) { tasSeti[t] = 1; });

    return {
      test_kod: D.testId, tur: 'numeroloji',
      email: adres, ad: D.ad, soyad: D.soyad,
      dogum: D.gun + ' ' + AYLAR[D.ay - 1] + ' ' + D.yil,
      dogum_gun: D.gun, dogum_ay: D.ay, dogum_yil: D.yil,
      yasam_yolu: p.yasamYolu.deger,
      yasam_yolu_ad: byy.ad,
      yasam_yolu_oz: byy.oz,
      yasam_yolu_metin: byy.yol,
      gezegen: byy.gezegen,
      renk: byy.renk,
      kader: p.kader.deger, kader_metin: sayiBilgi(p.kader.deger).kader,
      ruh: p.ruhArzusu.deger, ruh_metin: sayiBilgi(p.ruhArzusu.deger).ruh,
      kisilik: p.kisilik.deger, kisilik_metin: sayiBilgi(p.kisilik.deger).kisilik,
      olgunluk: p.olgunluk.deger,
      kisisel_yil: p.kisiselYil,
      kisisel_yil_ad: I.YIL[p.kisiselYil].ad,
      kisisel_yil_metin: I.YIL[p.kisiselYil].ozet,
      su_yil: p.suYil,
      karmik: p.karmik.eksik.map(function (n2) { return { n: n2, m: I.KARMIK[n2] }; }),
      ders: byy.ders,
      guc: byy.guc, golge: byy.golge,
      odak_ad: I.ALAN[alanKey].ad,
      odak_metin: I.ALAN[alanKey].sayi[p.yasamYolu.deger],
      taslar: Object.keys(tasSeti),
      urunler: liste,
      kendin_tasarla: location.origin + '/pages/kendin-tasarla',
      sayfa: location.origin + location.pathname
    };
  }

  /* ---------------------------------------------------------- başlat */
  ekran('gate');
})();
